import {
  ActivatedRouteSnapshot,
  NavigationStart,
  Router,
} from '@angular/router';
import { get, has } from 'lodash';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export function findInheritedRouteData<T = unknown>(
  route: ActivatedRouteSnapshot,
  key: string
): T | undefined {
  if (has(route.data, key)) {
    return get(route.data, key) as T;
  }
  if (route.parent) {
    return findInheritedRouteData(route.parent, key);
  }
}

export type RouterLinkData = string | string[];

export function openBlankTab(title: string, body: string): void {
  const tab = window.open('about:blank', '_blank');
  tab?.document.write(`
    <html>
      <head>
        <title>${title}</title>
      </head>
      <body>${body}</body>
    </html>
  `);
  tab?.document.close();
}

export function onRouteChange$(router: Router): Observable<NavigationStart> {
  return router.events.pipe(
    filter((event) => event instanceof NavigationStart)
  );
}
